import { OrderWithItems } from 'common-models';
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PaymentStepper } from "src/components/checkout/PaymentStepper";
import { useGetOrderQuery } from "src/features/events/eventShopApiSlice";
import PageIsLoading from "../../components/PageIsLoading";
import { PaymentView } from "../../components/checkout/PaymentView";

const CheckoutInProgressPage: FC<any> = () => {

    const params = useParams();
    const orderId = params.orderId as string;
    const { data = undefined as unknown as OrderWithItems } = useGetOrderQuery(orderId);

    const [order, setOrder] = useState(undefined as unknown as OrderWithItems);
    const [currentPaymentStep, setCurrentPaymentStep] = useState(0);

    useEffect(() => {
        if (data) {
            setOrder(data);
        }
    }, [data])

    const setCurrentStepCallback = (currentStep: number) => setCurrentPaymentStep(currentStep);

    return (
        <>
            <PaymentStepper currentStep={currentPaymentStep} />
            {
                order ? <PaymentView orderId={order.id} setCurrentPaymentStep={setCurrentStepCallback} /> : <PageIsLoading />
            }
        </>
    );
    // }
};

export default CheckoutInProgressPage;
